module.exports = __webpack_public_path__ + "static/media/protocol-ind.eff7004a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/protocol-ind.png
// module id = 43
// module chunks = 1